const $maps = $('.map');

if ($maps.length) {
    require(['./../version', 'scriptjs/dist/script'], (version, $script) => {
        // load google maps
        $script('https://maps.googleapis.com/maps/api/js?key=AIzaSyC8L4lKytcd0KbYEAfhT0aqzGkjh2Phr9M', () => {
            // loop over map container
            $maps.each(function (i, container) {
                let $container = $(container),
                    map = new google.maps.Map($container.find('.map__iframe')[0]),
                    markers = [],
                    bounds = new google.maps.LatLngBounds();

                // add placemarks to the map
                $container.find('.map__list__item div').each(function (i, item) {
                    let $item = $(item),
                        pinFile = 'assets/img/placemarks/marker.png',
                        position = new google.maps.LatLng($item.data('lat'), $item.data('lng'));

                    markers.push(position);

                    version(pinFile).then(function (pin) {
                        let marker = new google.maps.Marker({
                            map,
                            position,
                            title: $item.data('title'),
                            cursor: 'pointer',
                            icon: {
                                size: new google.maps.Size(600, 495),
                                scaledSize: new google.maps.Size(36, 33),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(24, 43),
                                url: pin,
                            },
                        });

                        marker.addListener('click', () => {
                            $item.find('a')[0].click();
                        });
                    });
                });

                // set the bounds based on the markers
                markers.forEach(position => { bounds.extend(position); });

                map.fitBounds(bounds);
            });
        });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/layouts/map.js